import React from "react";
import {
  AccessTime,
  InfoOutlined,
  RouteOutlined,
  LocationOnOutlined,
  DescriptionOutlined,
} from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

import { localizeDateTimeShort } from "utils/dateFormats";
import { useRouteShipmentDetailContext } from "contexts/RouteShipmentDetailContext";

const RouteShipmentBasicDetail = () => {
  const { routeShipmentDetail, loadingRouteShipment } =
    useRouteShipmentDetailContext();
  return !loadingRouteShipment ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <RouteOutlined color="primary" />}
            title="Route Name"
            subtitle={routeShipmentDetail?.routeName}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <DescriptionOutlined color="primary" />}
            title="Description"
            subtitle={routeShipmentDetail?.description ?? "N/A"}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocationOnOutlined color="primary" />}
            title="Origin"
            subtitle={
              <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                {routeShipmentDetail?.origin.name ?? "N/A"} (
                {routeShipmentDetail?.origin?.code ?? "N/A"})
              </Typography>
            }
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocationOnOutlined color="primary" />}
            title="Destination"
            subtitle={
              <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                {routeShipmentDetail?.destination.name ?? "N/A"} (
                {routeShipmentDetail?.destination?.code ?? "N/A"})
              </Typography>
            }
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <AccessTime color="primary" />}
            title="Total Time"
            subtitle={`${routeShipmentDetail?.routeTime ?? 0} min`}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <RouteOutlined color="primary" />}
            title="Total Distance"
            subtitle={`${routeShipmentDetail?.routeDistance ?? 0} km`}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Total Cost"
            subtitle={`₹${
              routeShipmentDetail?.routeCost?.toFixed(2) ?? "0.00"
            }`}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <AccessTime color="primary" />}
            title="Created At"
            subtitle={localizeDateTimeShort(routeShipmentDetail?.createdAt)}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
          >
            <Status isActive={routeShipmentDetail?.isActive} />
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default RouteShipmentBasicDetail;
